import React, { useState } from 'react';
import { Drawer, List, ListItem, ListItemText, Box } from '@mui/material';
import { Logout, Home, Inventory2, ReceiptLong, Description, RequestQuote, ContentPaste, Business, People, Payments, Checklist } from '@mui/icons-material';
import { useNavigate, useParams } from "react-router-dom";
import { pink } from '@mui/material/colors';
import { useGlobalContext } from "../GlobalContext";

const SideMenu = () => {
  const { isOpenDrawer, closeDrawer } = useGlobalContext();
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <Drawer open={isOpenDrawer} onClose={closeDrawer} sx={{ width: 250, flexShrink: 0 }}>
      <Box sx={{ width: 250, paddingTop: 10 }}>
        <List>
          <ListItem button>
            <Home />
            <ListItemText primary="Home" style={{ marginLeft: 2 }} />
          </ListItem>
          <ListItem button onClick={() => navigate(`/warehouse/${id}/picking-system`)} style={{ cursor: "pointer" }}>
            <Checklist />
            <ListItemText primary="Inventory" style={{ marginLeft: 2 }} />
          </ListItem>
          <ListItem button>
            <Inventory2 />
            <ListItemText primary="Warehouse" style={{ marginLeft: 2 }} />
          </ListItem>
          <ListItem button>
            <Description />
            <ListItemText primary="Invoicing" style={{ marginLeft: 2 }} />
          </ListItem>
          <ListItem button onClick={() => navigate(`/sales-orders/${id}/new`)} style={{ cursor: "pointer" }}>
            <RequestQuote />
            <ListItemText primary="Sales" style={{ marginLeft: 2 }} />
          </ListItem>
          <ListItem button>
            <ReceiptLong />
            <ListItemText primary="Orders" style={{ marginLeft: 2 }} />
          </ListItem>
          <ListItem button>
            <Payments />
            <ListItemText primary="Pricing" style={{ marginLeft: 2 }} />
          </ListItem>
          <ListItem button>
            <ContentPaste />
            <ListItemText primary="Purchasing" style={{ marginLeft: 2 }} />
          </ListItem>
          <ListItem button>
            <People />
            <ListItemText primary="Users" style={{ marginLeft: 2 }} />
          </ListItem>
          <hr />
          <ListItem button onClick={() => navigate("/select-company")} style={{ cursor: "pointer" }}>
            <Business />
            <ListItemText primary="Companies" style={{ marginLeft: 2 }} />
          </ListItem>
          <ListItem button>
            <Logout sx={{ color: pink[500] }} />
            <ListItemText primary="Logout" style={{ color: pink[500], marginLeft: 2 }} />
          </ListItem>
        </List>
      </Box>
    </Drawer>
  )
}

export default SideMenu;